<template>
  <v-dialog v-model="dialog" persistent no-click-animation width="1000">
    <v-stepper v-model="st">
      <v-stepper-header>
        <v-stepper-step step="1"></v-stepper-step>
        <v-stepper-step step="2"></v-stepper-step>
        <v-stepper-step step="3"></v-stepper-step>
        <v-stepper-step step="4"></v-stepper-step>
        <v-stepper-step step="5"></v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <welcome-step
            :title="$t('step1.title', { username })"
            :description="$t('step1.description')"
            :img="{ file: 'step1.png', width: 269, height: 212 }"
            :step="1"
            :steps="steps"
            @next="next()"
          ></welcome-step>
        </v-stepper-content>
        <v-stepper-content step="2">
          <welcome-step
            :title="$t('step2.title')"
            :description="$t('step2.description')"
            :img="{ file: 'step2.png', width: 291, height: 252 }"
            :step="2"
            :steps="steps"
            @prev="prev()"
            @next="next()"
          ></welcome-step>
        </v-stepper-content>
        <v-stepper-content step="3">
          <welcome-step
            :title="$t('step3.title')"
            :description="$t('step3.description')"
            :img="{ file: 'step3.png', width: 332, height: 147 }"
            :step="3"
            :steps="steps"
            @prev="prev()"
            @next="next()"
          ></welcome-step>
        </v-stepper-content>
        <v-stepper-content step="4">
          <welcome-step
            :title="$t('step4.title')"
            :description="$t('step4.description')"
            :img="{ file: 'step4.png', width: 284, height: 155 }"
            :step="4"
            :steps="steps"
            @prev="prev()"
            @next="next()"
          ></welcome-step>
        </v-stepper-content>
        <v-stepper-content step="5">
          <welcome-step
            :title="$t('step5.title')"
            :description="$t('step5.description')"
            :step="5"
            :steps="steps"
            @prev="prev()"
            @next="next()"
          >
            <v-spacer></v-spacer>
            <v-card flat class="choice pa-2 mb-5 d-block">
              <v-card-text class="pa-0">
                <div class="title">{{ $t('saas.title') }}</div>
                <div class="description">{{ $t('saas.description') }}</div>
              </v-card-text>
            </v-card>
            <v-card flat class="choice pa-2 d-block">
              <v-card-text class="pa-0">
                <div class="title">{{ $t('hybrid.title') }}</div>
                <div class="description">{{ $t('hybrid.description') }}</div>
              </v-card-text>
            </v-card>
            <v-spacer></v-spacer>
          </welcome-step>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import Step from '@/components/welcome/Step.vue'

export default {
  data () {
    return {
      dialog: true,
      st: 1,
      steps: 5,
      status: 0,
      duration: 20000,
      completion: 0
    }
  },
  computed: {
    username () {
      const user = this.$store.state.user
      return user && user.name
    }
  },
  methods: {
    next () {
      this.st++
      if (this.st === 6) {
        this.complete()
      }
    },
    prev () {
      this.st--
    },
    complete () {
      this.$emit('complete')
    }
  },
  components: {
    'welcome-step': Step
  }
}
</script>

<style scoped lang="scss">
.v-stepper__header {
  display: none !important;
}

.progress {
  height: 70vh;
  padding: 1.5rem;

  .v-stepper {
    box-shadow: none;
  }
}

.choice {
  height: auto;
  text-transform: none;

  .title {
    margin-bottom: .25rem;
    text-align: center;
  }
}

.v-list {
  margin-left: 5rem;
  margin-top: 3rem;
}
</style>

<i18n>
{
  "en": {
    "step1": {
      "title": "Welcome to Unryō!",
      "description": "You’re about to discover Unryō, the hybrid multi-cloud monitoring analytic platform for Large Enterprises and Service Providers."
    },
    "step2": {
      "title": "Full stack monitoring",
      "description": "Unryō gathers data from various technologies, and transforms it into valuable dashboards and insights for your users and customers."
    },
    "step3": {
      "title": "Felxible deployment options",
      "description": "Go hybrid multi-cloud or SaaS ? You decide. Deploy components on premises and in your public clouds. Or simply use it as a SaaS service hosted by us. We support your setup."
    },
    "step4": {
      "title": "Multi-clouds made simple",
      "description": "The future is about moving quickly. Deploy Unryo containerized components anywhere, and move them at any time, based on performance, cost, user proximity or security requirements. See them connect automatically and work in harmony as one consistent service. All of this in just few clicks. Endless possibilities."
    },
    "step5": {
      "title": "Let's get started",
      "description": "Unryō can be used in many different ways... Here are the most common examples."
    },
    "saas": {
      "title": "SaaS",
      "description": "The easiest way to get started! As a fully Software-as-a-Service (SaaS), we host and manage everything for you. You just have to deploy collectors on your infrastructure."
    },
    "hybrid": {
      "title": "Hybrid multi-cloud",
      "description": "Select which services you need – collection, storage, presentation, analytic - and deploy them in a click, individually, easily and securely, anywhere you want: on premises and in your public clouds. Your hybrid multi-cloud service, delivered with cloud-like simplicity!"
    },
    "prev": "Prev",
    "next": "Next",
    "finish": "Finish"
  }
}
</i18n>
